export const en = {
    'no-phrases-for-replace': 'Replacement keywords not found'
};
